<template lang="html">
<div>
  <b-row>
    <b-col sm="12">
      <b-card >
        <b-row class="pt-sm-1">
          <b-col sm="12">
            <span class="card-title wise-card-title">(비로그인) 문의사항 관리 </span>
          </b-col>
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>회원검색</strong></b-col>
          <b-col sm="2">
            <b-form-input v-model="queryParams.name" placeholder="" v-on:keyup="$event.keyCode === 13 ? findQA() : ''"></b-form-input>
          </b-col>
          <b-col sm="1"><strong>질문내용</strong></b-col>
          <b-col sm="2">
            <b-form-input v-model="queryParams.content" placeholder="" v-on:keyup="$event.keyCode === 13 ? findQA() : ''"></b-form-input>
          </b-col>
          <b-col sm="1">
            <b-button variant="primary" v-on:click="findQA()">검색</b-button>
          </b-col>
        </b-row>
        <!-- <b-row class="pt-sm-2">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>질문구분</strong></b-col>
          <b-col sm="2">
            <b-form-select id="basicSelect" v-model="queryParams.searchType"
              :plain="true"
              :options="productSearchType"
              :value="'all'">
            </b-form-select>
          </b-col>
        </b-row> -->
        <b-row class="pt-sm-2">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>날짜</strong></b-col>
          <b-col sm="1">
            <input type="text" id="fromdate" style="width:100%;text-align:center;border:1px solid #c2cfd6" v-on:keydown="keyhandler">
          </b-col>
          <b-col sm="1">
            <input type="text" id="todate" style="width:100%;text-align:center;border:1px solid #c2cfd6" v-on:keydown="keyhandler">
          </b-col>
          <b-col sm="1"><strong>응대상태</strong></b-col>
          <b-col sm="2">
            <b-form-select
              v-model="queryParams.qastatus"
              :value='0'
              :options="{ '0': '전체', '1': '응대대기', '2': '응대완료'}"
              id="inline-form-custom-select-pref1"
            >
            </b-form-select>
          </b-col>
        </b-row>
        <!-- ////////////////////////////////////////////////////////////////////////////////////////////// -->
        <hr>
        <b-row class="mt-sm-5">
          <b-col sm="12">
            <!-- <h4>※비로그인 문의사항은 사내메일시스템을 사용하여 응대 부탁드립니다.</h4>
            <br>   -->
            <b-card no-body>
              <b-tabs card>
                <b-tab title="전체" active>
                  <b-col sm="12" class="pt-5">
                    <b-table
                      hover
                      outlined
                      :fields="qnaFields"
                      :items="qnaItems"
                      :current-page="qnaCurrentPage"
                      :per-page="qnaPerPage"
                      @row-clicked="qnaRowSelected"
                    >
                    </b-table>
                  </b-col>
                  <b-col sm="12" class="pt-sm-1">
                    <b-row class="pb-sm-2">
                      <b-col sm="1"></b-col>
                      <b-col sm="10" class="my-1">
                        <b-pagination
                          v-model="qnaCurrentPage"
                          :total-rows="qnaTotalRows"
                          :per-page="qnaPerPage"
                          align="center"
                        ></b-pagination>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-tab>
              </b-tabs>
            </b-card>
            <table class="table table-bordered oddBackground">
              <tbody>
              <tr>
                <td style="width:20%">
                  고객 문의 내역
                  <br>작성자 : {{selectedQNA.user_name}}
                  <br>등록일 : {{selectedQNA.reg_date}}
                </td>
                <td style="width:80%">
                  <div>
                    <p class="card-text" style="white-space:pre-line;">
                      {{selectedQNA.contents}}
                    </p>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
            <table class="table table-bordered oddBackground">
              <tbody>
              <tr>
                <td style="width:20%">
                  관리자 답변 내역
                  <span v-if="selectedQNA.qastatus=='2'">
                      <br>답변자 : {{selectedQNA.reply_reg_user}}
                      <br/>{{selectedQNA.reply_date}}
                    </span>
                  <br/>
                  <b-button v-if="selectedQNA.qastatus=='1'" variant="primary" v-on:click="replySave()">저장</b-button>
                  <!--                  <b-button v-if="selectedQNA.qastatus=='2'" variant="primary" v-on:click="replyUpdate()">변경</b-button>-->
                  <!--                  <b-button v-if="selectedQNA.qastatus=='2'" variant="primary" v-on:click="replyDelete()">삭제</b-button>-->
                </td>
                <td style="width:80%">
                  <p class="card-text" style="white-space:pre-line;">
                    <textarea name="" id=""  style="width:100%;height:150px;"
                              v-model="selectedQNA.reply"
                    >
                    </textarea>
                  </p>
                </td>
              </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</div>
</template>

<script>
import swal from 'sweetalert2';
import datepicker from 'jquery-ui/ui/widgets/datepicker.js'
import datetimepicker from "daterangepicker/daterangepicker.js";
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
const moment = require("moment");

export default {
  data() {
    return {
      userInfo:{},
      queryParams: {
        name: '',
        content: '',
        endDate: '',
        startDate: '',
        searchType: 'all',
        qastatus:'0',
      },
      productSearchType: [
        {text:'전체', value:'all'},
        {text:'상품문의', value:'QA_TYPE_1'},
        {text:'구입문의', value:'QA_TYPE_2'},
        {text:'광고 및 제휴문의', value:'QA_TYPE_3'},
        {text:'계정문의', value:'QA_TYPE_4'},
        {text:'기타문의', value:'QA_TYPE_5'},
      ], // 상
      qnaTotalRows: 0,
      qnaCurrentPage: 1,
      qnaPerPage: 5,
      qnaPageOptions: [5, 10, 30, 50, 100],
      qnaFields: [
        {
          'type_name': {
            'label': '분류',
            'thStyle': { 'width': '10%'},
          }
        }, {
          'user_name': {
            'label': '작성자',
            'thStyle': { 'width': '7%'},
          }
        }, {
          'user_email': {
            'label': '이메일',
            'thStyle': { 'width': '5%'},
          }
        }, {
          'user_phone': {
            'label': '전화번호',
            'thStyle': { 'width': '10%'},
          }
        }, {
          'contents': {
            'label': '내용',
          }
        }, {
          'reg_date': {
            'label': '등록일',
            'thStyle': { 'width': '10%'},
          }
        },
        {
          'qastatus_name': {
            'label': '응대상태',
            'thStyle': { 'width': '10%'},
          }
        }
        // , {
        //   'reply_date': {
        //     'label': '응대일자',
        //     'thStyle': { 'width': '5%'},
        //   }
        // }
        // , {
        //   'qastatus_change': {
        //     'label': '응대변경',
        //   }
        // }
      ],
      qnaItems: [],
      qna_name: '',
      selectedQNA:{
        id:'',
        conn_id:'',
        title:'',
        reg_user:'',
        reg_date:'',
        check_yn:'',
        type_code:'',
        contents:'',
        user_name:'',
        join_date:'',
        mobile:'',
        type_name:'',
        reply:'',
        qastatus:'',
        qastatus_name:'',
        reply_date:'',
        reply_id:0,
        reply_reg_user:'',

      },
    }
  },
  components: {
    // PulseLoader
  },
  watch: {},
  mounted: function() {
    this.userInfo = this.$session.get('userInfo');

    var self = this;
    $("#fromdate").datepicker({
        dateFormat: 'yy-mm-dd' //Input Display Format 변경
        ,showOtherMonths: true //빈 공간에 현재월의 앞뒤월의 날짜를 표시
        ,showMonthAfterYear:true //년도 먼저 나오고, 뒤에 월 표시
        ,changeYear: true //콤보박스에서 년 선택 가능
        ,changeMonth: true //콤보박스에서 월 선택 가능
        ,buttonImageOnly: true //기본 버튼의 회색 부분을 없애고, 이미지만 보이게 함
        ,buttonText: "선택" //버튼에 마우스 갖다 댔을 때 표시되는 텍스트
        ,yearSuffix: "년" //달력의 년도 부분 뒤에 붙는 텍스트
        ,monthNamesShort: ['1','2','3','4','5','6','7','8','9','10','11','12'] //달력의 월 부분 텍스트
        ,monthNames: ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월'] //달력의 월 부분 Tooltip 텍스트
        ,dayNamesMin: ['일','월','화','수','목','금','토'] //달력의 요일 부분 텍스트
        ,dayNames: ['일요일','월요일','화요일','수요일','목요일','금요일','토요일'] //달력의 요일 부분 Tooltip 텍스트
        ,minDate: "" //최소 선택일자(-1D:하루전, -1M:한달전, -1Y:일년전)
        ,maxDate: "" //최대 선택일자(+1D:하루후, -1M:한달후, -1Y:일년후)
        ,onSelect: function(dateText, inst) {
          self.queryParams.startDate = dateText;
        }
    });
    this.queryParams.startDate = moment().add(-1, 'years').format('YYYY-MM-DD')
    $("#fromdate").datepicker('setDate', moment().add(-1, 'years').format('YYYY-MM-DD'));

    $("#todate").datepicker({
        dateFormat: 'yy-mm-dd' //Input Display Format 변경
        ,showOtherMonths: true //빈 공간에 현재월의 앞뒤월의 날짜를 표시
        ,showMonthAfterYear:true //년도 먼저 나오고, 뒤에 월 표시
        ,changeYear: true //콤보박스에서 년 선택 가능
        ,changeMonth: true //콤보박스에서 월 선택 가능
        ,buttonImageOnly: true //기본 버튼의 회색 부분을 없애고, 이미지만 보이게 함
        ,buttonText: "선택" //버튼에 마우스 갖다 댔을 때 표시되는 텍스트
        ,yearSuffix: "년" //달력의 년도 부분 뒤에 붙는 텍스트
        ,monthNamesShort: ['1','2','3','4','5','6','7','8','9','10','11','12'] //달력의 월 부분 텍스트
        ,monthNames: ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월'] //달력의 월 부분 Tooltip 텍스트
        ,dayNamesMin: ['일','월','화','수','목','금','토'] //달력의 요일 부분 텍스트
        ,dayNames: ['일요일','월요일','화요일','수요일','목요일','금요일','토요일'] //달력의 요일 부분 Tooltip 텍스트
        ,minDate: "" //최소 선택일자(-1D:하루전, -1M:한달전, -1Y:일년전)
        ,maxDate: "" //최대 선택일자(+1D:하루후, -1M:한달후, -1Y:일년후)
        ,onSelect: function(dateText, inst) {
          self.queryParams.startDate = dateText;
        }
    });
    this.queryParams.endDate = moment().format('YYYY-MM-DD')
    $("#todate").datepicker('setDate', moment().format('YYYY-MM-DD'));

    this.findQA();
  },
  methods: {
    keyhandler(event){
      event.preventDefault();
    },
    qnaRowSelected(item, index, event){
      this.selectedQNA = item;
    },
    findQA() {
      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(this.queryParams));

      var data = new FormData();
      data.append('objs', param);

      this.$http.post('/api/select/qaPublicList?access_token=' + token, data, null)
        .then((result) => {
          console.log(result.data);
          this.qnaTotalRows = result.data.length;
          this.qnaItems = result.data;
      });
    },
    replySave(){

      var token = sessionStorage.getItem("myToken");
      this.selectedQNA.reply_date = moment().format('YY-MM-DD HH:mm:ss');
      this.selectedQNA.reply_reg_user = this.userInfo.manager_id;
      var param = encodeURI(JSON.stringify(this.selectedQNA));

      var data = new FormData();
      data.append('objs', param);

      this.$http.post('/api/insert/qaPublicReply?access_token=' + token, data, null)
        .then((result) => {
          if(result.data > 0){
            swal.fire({
              type: 'success',
              title: '답변을 등록 했습니다.',
              showConfirmButton: false,
              timer: 1500
            })
            this.selectedQNA.qastatus = '2';
            this.selectedQNA.qastatus_name = '응대완료';
            this.selectedQNA.reply_id = result.data;
          }
      });
    },
    replyUpdate(){
      var token = sessionStorage.getItem("myToken");
      this.selectedQNA.reply_date = moment().format('YY-MM-DD HH:mm:ss');
      this.selectedQNA.reply_reg_user = this.userInfo.manager_id;
      var param = encodeURI(JSON.stringify(this.selectedQNA));

      var data = new FormData();
      data.append('objs', param);

      this.$http.post('/api/update/qaReply?access_token=' + token, data, null)
        .then((result) => {
          if(result.data == 'ok'){
            swal.fire({
              type: 'success',
              title: '답변을 변경 했습니다.',
              showConfirmButton: false,
              timer: 1500
            })
            this.selectedQNA.qastatus = '2';
          }
      });
    },
    replyDelete(){
      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(this.selectedQNA));

      var data = new FormData();
      data.append('objs', param);

      this.$http.post('/api/delete/qaReply?access_token=' + token, data, null)
        .then((result) => {
          if(result.data == 'ok'){
            swal.fire({
              type: 'success',
              title: '답변을 삭제 했습니다.',
              showConfirmButton: false,
              timer: 1500
            })
            this.selectedQNA.qastatus = '1';
            this.selectedQNA.qastatus_name = '응대대기';
            this.selectedQNA.reply_date = '';
            this.selectedQNA.reply = '';
            this.selectedQNA.reply_id = null;
          }
      });
    }
  }
}
</script>

<style src="daterangepicker/daterangepicker.css"></style>
<style lang="css" scoped>
.oddBackground td:nth-child(odd) {
  background:#dcdcdc;
  font-weight: 600;
}
.theader{
  background:#dcdcdc;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/views/customer/QAManagerPublic.vue